"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _clsx = _interopRequireDefault(require("clsx"));
var _component = _interopRequireDefault(require("@loadable/component"));
var _IconButton = _interopRequireDefault(require("../IconButton"));
var _TimeButton = _interopRequireDefault(require("../TimeButton"));
var _parseStringToDate = _interopRequireDefault(require("@micado-digital/react-ui/utils/parseStringToDate"));
var _parseDateToGermanDateString = _interopRequireDefault(require("@micado-digital/react-ui/utils/parseDateToGermanDateString"));
var _useLocals = _interopRequireDefault(require("@micado-digital/react-ui/hooks/useLocals"));
var _Local = _interopRequireDefault(require("@micado-digital/react-ui/components/Local"));
var _de = _interopRequireDefault(require("../../locals/de.json"));
var _en = _interopRequireDefault(require("../../locals/en.json"));
var _Intro = _interopRequireDefault(require("./Intro.styles"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const ReactDatepicker = (0, _component.default)(() => import("@micado-digital/react-datepicker/ReactDatepicker"));
const ReactOverlay = (0, _component.default)(() => import("@micado-digital/react-overlay/ReactOverlay"));
const ReactSVGIcon = (0, _component.default)(() => import("@micado-digital/react-svg-icon/ReactSVGIcon"));
const Typography = (0, _component.default)(() => import("@micado-digital/react-ui/components/Typography"));
const Intro = _ref => {
  let {
    currentTime,
    dateString,
    setCurrentTime,
    lang,
    onChangeDate,
    onLocateUser,
    onSelectLocation
  } = _ref;
  const {
    REACT_APP_PATH
  } = process.env;
  const css = (0, _Intro.default)();
  const [localDate, setLocalDate] = (0, _react.useState)();
  const [showDatepicker, setShowDatepicker] = (0, _react.useState)(false);
  const l = (0, _useLocals.default)({
    lang: lang,
    res: {
      de: _de.default,
      en: _en.default
    }
  });
  (0, _react.useEffect)(() => {
    if (dateString) {
      setLocalDate((0, _parseStringToDate.default)(dateString));
    }
  }, [dateString]);
  const handleShopDatepicker = () => {
    setShowDatepicker(true);
  };
  const handleChangeDate = date => {
    setShowDatepicker(false);
    onChangeDate((0, _parseDateToGermanDateString.default)(date));
  };
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)(css.intro, "mco-bus-stops-intro")
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)(css.buttons, "mco-bus-stops-intro__buttons")
  }, /*#__PURE__*/_react.default.createElement(_IconButton.default, {
    icon: "calendar.svg",
    identifier: "date",
    lang: lang,
    value: dateString,
    onClick: handleShopDatepicker
  }), /*#__PURE__*/_react.default.createElement(_TimeButton.default, {
    currentTime: currentTime,
    setCurrentTime: setCurrentTime,
    lang: lang
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)(css.actionWrapper, "mco-bus-stops-intro__action-wrapper")
  }, /*#__PURE__*/_react.default.createElement(Typography, {
    className: (0, _clsx.default)(css.headline, "mco-bus-stops-intro__action-wrapper-headline"),
    dangerouslySetInnerHTML: {
      __html: l("reactBusStops.intro.headline")
    },
    variant: "h5"
  }), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)(css.item, "mco-bus-stops-intro__action-wrapper-item"),
    onClick: onLocateUser
  }, /*#__PURE__*/_react.default.createElement(ReactSVGIcon, {
    color: "primary",
    src: REACT_APP_PATH + "/img/icons/bus-stops/location.svg",
    size: 48
  }), /*#__PURE__*/_react.default.createElement(Typography, {
    component: "p",
    className: (0, _clsx.default)(css.title, "mco-bus-stops-intro__action-wrapper-item-title"),
    dangerouslySetInnerHTML: {
      __html: l("reactBusStops.intro.getLocation")
    },
    variant: "h5"
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)(css.item, "mco-bus-stops-intro__action-wrapper-item"),
    onClick: onSelectLocation
  }, /*#__PURE__*/_react.default.createElement(ReactSVGIcon, {
    color: "primary",
    src: REACT_APP_PATH + "/img/icons/bus-stops/map.svg",
    size: 48
  }), /*#__PURE__*/_react.default.createElement(Typography, {
    component: "p",
    className: (0, _clsx.default)(css.title, "mco-bus-stops-intro__action-wrapper-item-title"),
    dangerouslySetInnerHTML: {
      __html: l("reactBusStops.intro.findLocation")
    },
    variant: "h5"
  }))), /*#__PURE__*/_react.default.createElement(_Local.default, {
    identifier: "reactBusStops.intro.addition",
    l: l
  }))), showDatepicker && /*#__PURE__*/_react.default.createElement(ReactOverlay, {
    avoidCloseOnOutsideClickAndESC: true,
    className: (0, _clsx.default)(css.overlay, "mco-bus-stops-overlay"),
    mode: "html",
    noPadding: true,
    size: 750,
    setOpen: setShowDatepicker,
    toolbarColor: "secondary",
    toolbarInside: true
  }, /*#__PURE__*/_react.default.createElement(_react.default.Suspense, null, /*#__PURE__*/_react.default.createElement(ReactDatepicker, {
    fullWeekdays: true,
    minDate: new Date(),
    months: 1,
    startDate: new Date(),
    selected: localDate,
    setSelected: handleChangeDate
  }))));
};
var _default = exports.default = Intro;